module.exports = {
	"core": {
		"blocksonly": 1
	},
	"network": {
		"maxconnections": 20,
		"maxuploadtarget": 500
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Presets/bandwidth.json
 ** module id = 40
 ** module chunks = 0
 **/